import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import PermissionsModal from './components/PermissionsModal'

const AcceptanceScreen = ({
  token,
  brand,
  documentTitle,
  language,
  startDate,
  endDate,
  meetingNumber,
  password,
}: {
  token: string
  brand: string
  documentTitle: string
  language: string
  startDate: string
  endDate: string
  meetingNumber: string
  password: string
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [showModal, setShowModal] = useState(false)
  const [infoHidden, setInfoHidden] = useState(false)
  const handleAccept = () => {
    setShowModal(true)
    setInfoHidden(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
    navigate(
      `/zoom/meeting/${token}?brand=${brand}&language=${language}&start_date=${startDate}&end_date=${endDate}&meeting_number=${meetingNumber}&password=${password}`,
    )
  }

  useEffect(() => {
    if (brand) {
      document.title = documentTitle
    }
  }, [documentTitle, brand])

  useEffect(() => {
    if (startDate) localStorage.setItem('startDate', startDate)
    if (endDate) localStorage.setItem('endDate', endDate)
    if (meetingNumber) localStorage.setItem('meeting_number', meetingNumber)
    if (password) localStorage.setItem('password', password)
  }, [startDate, endDate, meetingNumber, password])

  return (
    <>
      {infoHidden ? null : (
        <div className="w-[390px] md:w-[830px] flex-col items-center justify-center text-center mt-[48px] p-4 font-aeonik text-generic-neutral-900">
          {brand === 'vidacaixa' ? (
            <p className="text-[22px] font-semibold mb-4 text-center ">
              {t('zoom.acceptanceScreen.caixaTitle')}
            </p>
          ) : (
            <p className="text-[22px] font-semibold mb-4 text-center ">
              {t('zoom.acceptanceScreen.qidaTitle')}
            </p>
          )}

          <p className="text-center mb-6 mt-10 md:w-[767px] text-[20px]">
            {t('zoom.acceptanceScreen.text')}
          </p>

          <button
            onClick={handleAccept}
            className={`mt-6 py-2 px-10 text-[#E6E9EC] rounded-lg uppercase ${
              brand === 'vidacaixa'
                ? 'bg-[#007EAE] hover:bg-[#036085] focus:bg-[#007EAE] focus:ring-4 focus:ring-[#cce5f0] focus:outline-none'
                : 'bg-generic-primary-500 hover:bg-generic-primary-400 focus:bg-generic-primary-500 focus:ring-4 focus:ring-generic-primary-200 focus:outline-none'
            }`}
          >
            {t('zoom.acceptanceScreen.accept')}
          </button>
        </div>
      )}
      {showModal && (
        <PermissionsModal
          brand={brand}
          isOpen={showModal}
          handleAccept={handleAccept}
          handleCloseModal={handleCloseModal}
          onClose={handleCloseModal}
        />
      )}
    </>
  )
}

export default AcceptanceScreen
